import React from "react";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LogoutSecondaryIcon } from "../../../Common/Svgs/LogoutIcon";
import { updateHome } from "../../../Redux/Slices/home.slice";

const LoggedUserItem = ({ sidebarActive, setSidebarActive }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { userDetails } = useSelector((state) => state.loggedInUser);

  const initial =
    Object.entries(userDetails).length && userDetails?.firstName[0];

  const handleLogout = () => {
    dispatch(
      updateHome({
        key: "notifications",
        value: [],
      }),
    );

    localStorage.clear();

    navigate("/");
  };

  return (
    <motion.div
      layout
      className="absolute bottom-[29px] px-[19px] flex items-center justify-between w-full"
    >
      <motion.div
        role="button"
        className="w-[34px] h-[34px] absolute flex items-center justify-center bg-primary-50 rounded-full"
        onClick={() => setSidebarActive(true)}
      >
        <p className="font-poppins text-base font-medium uppercase text-sidebar-active">
          {initial}
        </p>
      </motion.div>

      <div className="w-[34px] h-[34px]" />

      {sidebarActive && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="flex items-center gap-x-2 cursor-pointer group"
          onClick={handleLogout}
        >
          <p className="font-aileron text-xs font-semibold text-sidebar-base group-hover:text-sidebar-active">
            Logout
          </p>

          <LogoutSecondaryIcon
            size={20}
            className="text-sidebar-base group-hover:text-sidebar-active"
          />
        </motion.div>
      )}
    </motion.div>
  );
};

export default LoggedUserItem;
